var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 862.40192 126.70164",
    className: "h-7 rounded",
    id: "svg336",
    width: 862.40192,
    height: 126.70164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs340"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g12308",
    transform: "scale(0.90603776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55.517839,-54.318538)",
    id: "g324"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 144.62,152 c 0,0 0.56,-31.37 0.15,-46.73 l 23.43,-1 C 161.93162,94.829008 154.7468,86.029696 146.75,78 c -2.66,-2.69 -5.55,-5.37 -9.16,-6.52 -3.61,-1.15 -9.77,-2.51 -13.34,-1.77 -6.55,1.37 -10.92,2.59 -15,7.85 -1.75,2.22 -2.55,9.77 -3.32,12.45 -6.5,0.59 -16.26,0.35 -20,4.12 -3.74,3.77 -1.74,11.61 2.26,12.41 4,0.8 16.17,0.93 16.17,0.93 0.18,14.63333 0.36333,32.21944 0.55,46.85277",
    fill: "none",
    className: "stroke-black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "7px",
    id: "path314",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 6.99968,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150.55,59.47 C 138.81,62.54 127,58.73 115,57.93 c -3.64,-0.24 -8.33,-0.09 -11.26,2.35 a 9.32,9.32 0 0 0 -3.08,10.47 c -7.06,0 -10,7.48 -8.57,17 6.8,0 9.85,1.49 13.27,7.29 1.79,3 7.44,2.85 8.1,-1.06 1.08,-6.34 1.68,-11.49 5.27,-16.5 14.44,1.37 23.87,-3 33,-9.33 3.8,-2.58 4.02,-10.04 -1.18,-8.68 z",
    className: "stroke-black fill-black",
    id: "path316",
    style: {
      stroke: "#000000",
      strokeWidth: 7,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 128.88,152 c 30.63,0 47.43,10.5 64.77,40.07 l -137.3,0.09 C 75.76,155.63 98.24,152 128.88,152 Z",
    className: "fill-primary-400 stroke-primary-400",
    id: "path318",
    style: {
      fill: "#facc15",
      fillOpacity: 1,
      stroke: "#facc15",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 96,156.14 c -0.11,3.45 2.75,6.26 5.7,8.06 5.17,3.17 12.29,4.54 17.07,0.8 3.06,-2.4 4.43,-6.31 5.66,-10 2,4.69 5.12,9.06 9.43,11.81 4.31,2.75 10,3.68 14.63,1.6 4.63,-2.08 7.88,-7.47 6.71,-12.45",
    fill: "none",
    className: "stroke-black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "7px",
    id: "path320",
    style: {
      stroke: "#000000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 125.52,173.66 -0.75,17",
    fill: "none",
    className: "stroke-black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "7px",
    id: "path322",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "stroke-black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "7px",
    id: "g330",
    transform: "translate(1.6147504e-4,3.5294616)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 83.667999,
    x2: 83.667999,
    y1: 30.302,
    y2: 35.012001,
    id: "line326",
    style: {
      stroke: "#000000",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.532997,
    x2: 69.532997,
    y1: 30.302,
    y2: 35.012001,
    id: "line328",
    style: {
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "stroke-black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px",
    id: "g334",
    transform: "translate(1.6147504e-4,3.5294616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 68.547,51.482 c 3.1039,3.1901 5.5922,4.0367 10.204,4.0926",
    id: "path332",
    style: {
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g7812",
    transform: "matrix(0.87551943,0,0,0.87551943,-2.6806848,1.7268469)"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "domain",
    id: "text5574",
    style: {
      fontWeight: "bold",
      fontSize: "96.3038px",
      fontFamily: "Inter",
      InkscapeFontSpecification: "'Inter Bold'",
      strokeWidth: 2.4076
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 199.51826,107.7478 q -5.98479,0 -10.84102,-3.07789 -4.82203,-3.11209 -7.66053,-9.13108 -2.8043,-6.053186 -2.8043,-14.842276 0,-9.028481 2.9069,-15.01327 2.90689,-6.018988 7.72892,-8.994283 4.85623,-3.009494 10.63583,-3.009494 4.41164,0 7.35274,1.504747 2.9753,1.470548 4.78783,3.69347 1.84674,2.188723 2.8043,4.309048 h 0.44459 V 36.853701 H 229.408 v 70.039129 h -14.36349 v -8.412903 h -0.61558 q -1.02596,2.188723 -2.9069,4.343243 -1.84673,2.12033 -4.82203,3.52248 -2.94109,1.40215 -7.18174,1.40215 z m 4.61684,-11.593391 q 3.52247,0 5.95059,-1.915133 2.46231,-1.949331 3.76186,-5.437608 1.33376,-3.488277 1.33376,-8.173512 0,-4.685234 -1.29956,-8.139312 -1.29955,-3.454079 -3.76187,-5.335012 -2.46231,-1.880934 -5.98478,-1.880934 -3.59088,0 -6.05319,1.949331 -2.46231,1.949332 -3.72767,5.40341 -1.26535,3.454078 -1.26535,8.002517 0,4.582639 1.26535,8.105115 1.29955,3.488276 3.72767,5.471807 2.46231,1.949331 6.05319,1.949331 z",
    id: "path7951"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 265.07729,107.91879 q -7.96831,0 -13.78211,-3.38568 -5.7796,-3.41988 -8.92588,-9.507261 -3.14629,-6.121584 -3.14629,-14.1925 0,-8.139313 3.14629,-14.226698 3.14628,-6.121584 8.92588,-9.507264 5.8138,-3.41988 13.78211,-3.41988 7.96832,0 13.74792,3.41988 5.81379,3.38568 8.96008,9.507264 3.14629,6.087385 3.14629,14.226698 0,8.070916 -3.14629,14.1925 -3.14629,6.087381 -8.96008,9.507261 -5.7796,3.38568 -13.74792,3.38568 z m 0.0684,-11.285598 q 3.62507,0 6.05319,-2.051928 2.42811,-2.086126 3.65927,-5.676999 1.26536,-3.590874 1.26536,-8.173512 0,-4.582638 -1.26536,-8.173512 -1.23116,-3.590873 -3.65927,-5.676999 -2.42812,-2.086127 -6.05319,-2.086127 -3.65927,0 -6.15578,2.086127 -2.46231,2.086126 -3.72767,5.676999 -1.23116,3.590874 -1.23116,8.173512 0,4.582638 1.23116,8.173512 1.26536,3.590873 3.72767,5.676999 2.49651,2.051928 6.15578,2.051928 z",
    id: "path7953"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 300.43881,106.89283 V 54.363483 h 13.88471 v 9.267873 h 0.61558 q 1.64154,-4.616837 5.47181,-7.284343 3.83026,-2.667506 9.16527,-2.667506 5.40341,0 9.19948,2.701705 3.79606,2.667506 5.06142,7.250144 h 0.54718 q 1.60734,-4.514241 5.81379,-7.215945 4.24066,-2.735904 10.02025,-2.735904 7.35274,0 11.93538,4.685235 4.61684,4.651036 4.61684,13.200734 V 106.89283 H 362.23603 V 74.438175 q 0,-4.377446 -2.32552,-6.566168 -2.32552,-2.188723 -5.81379,-2.188723 -3.96706,0 -6.18998,2.53071 -2.22293,2.496512 -2.22293,6.600368 v 32.078468 h -14.1241 V 74.130386 q 0,-3.864464 -2.22292,-6.155783 -2.18872,-2.291319 -5.7796,-2.291319 -2.42811,0 -4.37744,1.231156 -1.91513,1.196958 -3.04369,3.385681 -1.12856,2.154524 -1.12856,5.061421 v 31.531288 z",
    id: "path7955"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 403.24022,107.88459 q -5.02722,0 -8.96008,-1.74413 -3.93286,-1.77834 -6.22418,-5.23242 -2.25712,-3.488276 -2.25712,-8.686493 0,-4.377445 1.60734,-7.35274 1.60735,-2.975295 4.37745,-4.787831 2.7701,-1.812536 6.29258,-2.735904 3.55667,-0.923367 7.45533,-1.299554 4.58264,-0.478783 7.38694,-0.889168 2.8043,-0.444585 4.06966,-1.299555 1.26535,-0.854969 1.26535,-2.53071 v -0.205193 q 0,-3.248885 -2.05192,-5.027223 -2.01773,-1.778337 -5.7454,-1.778337 -3.93286,0 -6.25838,1.744138 -2.32552,1.70994 -3.07789,4.309048 l -13.47433,-1.094361 q 1.02597,-4.787831 4.03546,-8.276108 3.0095,-3.522476 7.76313,-5.403409 4.78783,-1.915133 11.08041,-1.915133 4.37744,0 8.3787,1.025964 4.03546,1.025964 7.14755,3.180488 3.14629,2.154524 4.95882,5.540204 1.81254,3.351482 1.81254,8.036717 v 35.42995 h -13.81631 v -7.284343 h -0.41039 q -1.26535,2.462313 -3.38568,4.343243 -2.12032,1.84674 -5.09562,2.9069 -2.97529,1.02596 -6.87396,1.02596 z m 4.17226,-10.05444 q 3.21468,0 5.677,-1.265356 2.46231,-1.299554 3.86446,-3.488277 1.40215,-2.188722 1.40215,-4.958825 v -5.574403 q -0.68398,0.444584 -1.88093,0.820771 -1.16276,0.341988 -2.63331,0.649777 -1.47055,0.27359 -2.9411,0.512982 -1.47054,0.205193 -2.6675,0.376187 -2.56491,0.376186 -4.48004,1.196957 -1.91514,0.820771 -2.9753,2.222922 -1.06016,1.367952 -1.06016,3.419879 0,2.975295 2.15452,4.54844 2.18872,1.538946 5.54021,1.538946 z",
    id: "path7957"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 444.14197,106.89283 V 54.363483 h 14.56868 v 52.529347 z m 7.31854,-59.300708 q -3.24889,0 -5.57441,-2.154524 -2.29132,-2.188723 -2.29132,-5.232415 0,-3.009494 2.29132,-5.164018 2.32552,-2.188723 5.57441,-2.188723 3.24888,0 5.5402,2.188723 2.32552,2.154524 2.32552,5.164018 0,3.043692 -2.32552,5.232415 -2.29132,2.154524 -5.5402,2.154524 z",
    id: "path7959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 484.90688,76.524301 V 106.89283 H 470.33819 V 54.363483 h 13.88471 v 9.267873 h 0.61558 q 1.74414,-4.582638 5.848,-7.250144 4.10385,-2.701705 9.95184,-2.701705 5.47181,0 9.54147,2.393916 4.06965,2.393915 6.32677,6.839758 2.25713,4.411645 2.25713,10.533229 v 33.44642 H 504.195 V 76.045518 q 0.0342,-4.82203 -2.46231,-7.523734 -2.49652,-2.735904 -6.87396,-2.735904 -2.9411,0 -5.19822,1.265355 -2.22292,1.265356 -3.48827,3.69347 -1.23116,2.393916 -1.26536,5.779596 z",
    id: "path7961"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "watchman",
    id: "text6354",
    style: {
      fontSize: "96.3038px",
      strokeWidth: 2.4076
    },
    transform: "translate(-6.8530746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 549.52805,106.50298 533.52301,53.973636 h 8.4813 l 11.354,40.217781 h 0.54718 L 565.1227,53.973636 h 8.61809 l 11.08041,40.080986 h 0.54718 l 11.354,-40.080986 h 8.4813 l -16.00503,52.529344 h -7.93412 l -11.4908,-40.354573 h -0.82077 l -11.49079,40.354573 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 631.33138,107.73414 q -4.99302,0 -9.06268,-1.88093 -4.06966,-1.91514 -6.46357,-5.50601 -2.39392,-3.625072 -2.39392,-8.754891 0,-4.514241 1.77834,-7.318542 1.77834,-2.8385 4.75363,-4.445843 2.9753,-1.607343 6.56617,-2.393915 3.62507,-0.820771 7.28434,-1.299555 4.78784,-0.615578 7.76313,-0.923367 3.00949,-0.341988 4.37745,-1.12856 1.40215,-0.786572 1.40215,-2.735904 v -0.27359 q 0,-5.061421 -2.77011,-7.865722 -2.7359,-2.804302 -8.3103,-2.804302 -5.7796,0 -9.06268,2.530711 -3.28309,2.530711 -4.61684,5.40341 l -7.66053,-2.735904 q 2.05193,-4.787831 5.47181,-7.455337 3.45408,-2.701705 7.52373,-3.761867 4.10386,-1.094362 8.07092,-1.094362 2.53071,0 5.81379,0.615579 3.31729,0.581379 6.39518,2.428114 3.11209,1.846735 5.16401,5.574403 2.05193,3.727669 2.05193,9.986048 v 34.609176 h -8.07091 v -7.113346 h -0.41039 q -0.82077,1.709936 -2.7359,3.659266 -1.91513,1.94934 -5.09562,3.31729 -3.18049,1.36795 -7.76313,1.36795 z m 1.23116,-7.25014 q 4.78783,0 8.07091,-1.880938 3.31729,-1.880934 4.99303,-4.856229 1.70994,-2.975295 1.70994,-6.258379 v -7.386939 q -0.51298,0.615578 -2.25712,1.12856 -1.70994,0.478783 -3.96706,0.85497 -2.22293,0.341987 -4.34325,0.615578 -2.08613,0.239391 -3.38568,0.410385 -3.14629,0.410386 -5.88219,1.333753 -2.70171,0.889169 -4.37745,2.701705 -1.64154,1.778337 -1.64154,4.856229 0,4.206451 3.11209,6.360975 3.14629,2.12033 7.96832,2.12033 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 693.02588,53.973636 v 6.839759 H 665.80364 V 53.973636 Z M 673.73776,41.38848 h 8.07091 v 50.067034 q 0,3.419879 0.99177,5.129819 1.02596,1.675741 2.59911,2.25712 1.60734,0.547181 3.38568,0.547181 1.33375,0 2.18872,-0.136795 0.85497,-0.170994 1.36795,-0.27359 l 1.64154,7.250141 q -0.82077,0.30779 -2.29132,0.61558 -1.47054,0.34199 -3.72766,0.34199 -3.41988,0 -6.70297,-1.47055 -3.24888,-1.47055 -5.40341,-4.48004 -2.12032,-3.009495 -2.12032,-7.592133 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 725.99347,107.59734 q -7.38694,0 -12.72196,-3.48827 -5.33501,-3.48828 -8.20771,-9.609863 -2.87269,-6.121584 -2.87269,-13.987307 0,-8.002518 2.94109,-14.124102 2.9753,-6.155783 8.27611,-9.609861 5.33501,-3.488277 12.44836,-3.488277 5.54021,0 9.98605,2.051928 4.44584,2.051928 7.28434,5.745397 2.8385,3.69347 3.52248,8.618096 h -8.07092 q -0.92337,-3.590873 -4.10385,-6.360975 -3.14629,-2.804301 -8.4813,-2.804301 -4.71944,0 -8.27611,2.462313 -3.52248,2.428114 -5.50601,6.873957 -1.94933,4.411645 -1.94933,10.362235 0,6.087385 1.91513,10.601626 1.94933,4.51424 5.47181,7.010752 3.55667,2.496512 8.34451,2.496512 3.14629,0 5.71119,-1.094361 2.56491,-1.094362 4.34325,-3.146289 1.77834,-2.051928 2.53071,-4.924626 h 8.07092 q -0.68398,4.651036 -3.38568,8.378704 -2.66751,3.693472 -7.07915,5.882192 -4.37745,2.15452 -10.19124,2.15452 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7982"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 766.48468,74.903298 v 31.599682 h -8.07092 V 36.463854 h 8.07092 v 25.717493 h 0.68398 q 1.84673,-4.069657 5.5402,-6.463572 3.72767,-2.428115 9.91765,-2.428115 5.36921,0 9.40467,2.154524 4.03546,2.120326 6.25838,6.53197 2.25712,4.377446 2.25712,11.148807 v 33.378019 h -8.07092 V 73.672141 q 0,-6.258379 -3.24888,-9.678258 -3.21469,-3.454078 -8.92589,-3.454078 -3.96706,0 -7.11335,1.675741 -3.11209,1.67574 -4.92462,4.890427 -1.77834,3.214687 -1.77834,7.797325 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 815.32047,106.50298 V 53.973636 h 7.79733 v 8.207711 h 0.68397 q 1.64154,-4.206452 5.30082,-6.53197 3.65927,-2.359717 8.78909,-2.359717 5.19821,0 8.65229,2.359717 3.48828,2.325518 5.43761,6.53197 h 0.54718 q 2.01773,-4.069657 6.05319,-6.463572 4.03545,-2.428115 9.67825,-2.428115 7.04496,0 11.525,4.411645 4.48004,4.377445 4.48004,13.645318 v 35.156357 h -8.07092 V 71.346623 q 0,-5.813795 -3.18048,-8.310306 -3.18049,-2.496512 -7.48954,-2.496512 -5.5402,0 -8.5839,3.351481 -3.04369,3.317283 -3.04369,8.412904 v 34.19879 H 845.689 V 70.525852 q 0,-4.480042 -2.9069,-7.215945 -2.90689,-2.770102 -7.48953,-2.770102 -3.14629,0 -5.88219,1.675741 -2.70171,1.67574 -4.37745,4.651035 -1.64154,2.941097 -1.64154,6.80556 v 32.830839 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 914.49695,107.73414 q -4.99302,0 -9.06268,-1.88093 -4.06965,-1.91514 -6.46357,-5.50601 -2.39391,-3.625072 -2.39391,-8.754891 0,-4.514241 1.77833,-7.318542 1.77834,-2.8385 4.75364,-4.445843 2.97529,-1.607343 6.56616,-2.393915 3.62508,-0.820771 7.28435,-1.299555 4.78783,-0.615578 7.76312,-0.923367 3.0095,-0.341988 4.37745,-1.12856 1.40215,-0.786572 1.40215,-2.735904 v -0.27359 q 0,-5.061421 -2.7701,-7.865722 -2.73591,-2.804302 -8.31031,-2.804302 -5.7796,0 -9.06268,2.530711 -3.28308,2.530711 -4.61684,5.40341 l -7.66053,-2.735904 q 2.05193,-4.787831 5.47181,-7.455337 3.45408,-2.701705 7.52374,-3.761867 4.10385,-1.094362 8.07091,-1.094362 2.53071,0 5.8138,0.615579 3.31728,0.581379 6.39517,2.428114 3.11209,1.846735 5.16402,5.574403 2.05193,3.727669 2.05193,9.986048 v 34.609176 h -8.07092 v -7.113346 h -0.41039 q -0.82077,1.709936 -2.7359,3.659266 -1.91513,1.94934 -5.09562,3.31729 -3.18049,1.36795 -7.76313,1.36795 z m 1.23116,-7.25014 q 4.78783,0 8.07092,-1.880938 3.31728,-1.880934 4.99302,-4.856229 1.70994,-2.975295 1.70994,-6.258379 v -7.386939 q -0.51298,0.615578 -2.25712,1.12856 -1.70994,0.478783 -3.96706,0.85497 -2.22292,0.341987 -4.34325,0.615578 -2.08612,0.239391 -3.38568,0.410385 -3.14629,0.410386 -5.88219,1.333753 -2.7017,0.889169 -4.37745,2.701705 -1.64154,1.778337 -1.64154,4.856229 0,4.206451 3.11209,6.360975 3.14629,2.12033 7.96832,2.12033 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 961.41754,74.903298 v 31.599682 h -8.07091 V 53.973636 h 7.79732 v 8.207711 h 0.68398 q 1.84673,-4.001259 5.6086,-6.429373 3.76187,-2.462314 9.71246,-2.462314 5.33501,0 9.33627,2.188723 4.00126,2.154524 6.22418,6.566169 2.22292,4.377445 2.22292,11.080409 v 33.378019 h -8.07092 V 73.672141 q 0,-6.189981 -3.21468,-9.644059 -3.21469,-3.488277 -8.82329,-3.488277 -3.86447,0 -6.90816,1.675741 -3.00949,1.67574 -4.75363,4.890427 -1.74414,3.214687 -1.74414,7.797325 z",
    style: {
      InkscapeFontSpecification: "inter"
    },
    id: "path7990"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f4b0c03b6674349fc7d5b5f99975a6c.svg";
export { ForwardRef as ReactComponent };